import React, { useEffect } from 'react';
import { Form, Input, Button, Card, Tabs, message } from 'antd';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../../../api/axios';
import { SaveOutlined } from '@ant-design/icons';

export const OleSiteConfigSettings: React.FC = () => {
    const [form] = Form.useForm();
    const queryClient = useQueryClient();

    const { data: configData, isLoading } = useQuery({
        queryKey: ['adminOleSiteConfig'],
        queryFn: async () => {
            const res = await apiClient.get('/admin/ole/site-config');
            return res.data;
        }
    });

    useEffect(() => {
        if (configData && configData.succeeded && configData.data) {
            const cd = configData.data;
            
            const formattedTranslations: any = {};
            cd.translations?.forEach((t: any) => {
                formattedTranslations[t.languageCode] = {
                    footerText: t.footerText,
                    siteDescription: t.siteDescription
                };
            });

            form.setFieldsValue({
                siteName: cd.siteName,
                logoUrl: cd.logoUrl,
                faviconUrl: cd.faviconUrl,
                facebookUrl: cd.facebookUrl,
                instagramUrl: cd.instagramUrl,
                tiktokUrl: cd.tiktokUrl,
                translations: formattedTranslations
            });
        }
    }, [configData, form]);

    const mutation = useMutation({
        mutationFn: async (values: any) => {
            const translations = Object.keys(values.translations || {}).map(lang => ({
                languageCode: lang,
                footerText: values.translations[lang]?.footerText || '',
                siteDescription: values.translations[lang]?.siteDescription || ''
            }));

            const payload = {
                siteName: values.siteName || '',
                logoUrl: values.logoUrl || '',
                faviconUrl: values.faviconUrl || '',
                facebookUrl: values.facebookUrl || '',
                instagramUrl: values.instagramUrl || '',
                tiktokUrl: values.tiktokUrl || '',
                translations
            };

            return apiClient.put('/admin/ole/site-config', payload);
        },
        onSuccess: () => {
            message.success('Site ayarları başarıyla güncellendi');
            queryClient.invalidateQueries({ queryKey: ['adminOleSiteConfig'] });
        },
        onError: () => {
            message.error('Site ayarları güncellenirken hata oluştu');
        }
    });

    const tabItems = [
        { key: 'de', label: 'Almanca (DE)' },
        { key: 'en', label: 'İngilizce (EN)' },
        { key: 'tr', label: 'Türkçe (TR)' }
    ];

    if (isLoading) return <div>Yükleniyor...</div>;

    return (
        <Card title="OLE Site Ayarları">
            <Form form={form} layout="vertical" onFinish={(values) => mutation.mutate(values)}>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <Form.Item name="siteName" label="Site Adı">
                        <Input />
                    </Form.Item>
                    <Form.Item name="logoUrl" label="Logo URL">
                        <Input placeholder="/media/public/images/logo.png" />
                    </Form.Item>
                    <Form.Item name="faviconUrl" label="Favicon URL">
                        <Input />
                    </Form.Item>
                    <Form.Item name="facebookUrl" label="Facebook Linki">
                        <Input />
                    </Form.Item>
                    <Form.Item name="instagramUrl" label="Instagram Linki">
                        <Input />
                    </Form.Item>
                    <Form.Item name="tiktokUrl" label="TikTok Linki">
                        <Input />
                    </Form.Item>
                </div>

                <Tabs defaultActiveKey="de" items={tabItems.map(tab => ({
                    key: tab.key,
                    label: tab.label,
                    children: (
                        <div style={{ padding: '1rem 0' }}>
                            <Form.Item name={['translations', tab.key, 'siteDescription']} label="Kısa Açıklama (Hakkımızda vb.)">
                                <Input.TextArea rows={3} />
                            </Form.Item>
                            <Form.Item name={['translations', tab.key, 'footerText']} label="Alt Bilgi (Footer) Metni">
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </div>
                    )
                }))} />

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={mutation.isPending} icon={<SaveOutlined />}>
                        Güncelle
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};
